














































































































































import Vue from "vue";
import { DeviceOptionsService } from "@/services/DeviceOptionsService";
import { Info } from "@/models/Info";

export default Vue.extend({
  name: "DeviceOptions",
  components: {},
  props: {
    info: {
      type: Object as () => Info,
      default: null
    }
  },
  data() {
    return {
      saving: false,
      deviceUserDefaults: this.info.cloudSettings.find(p => p.deviceUDID == this.info.selectedDevice.deviceUDID)!.userDefaultsObject,
      defaultOrderTypes: [
        { code: 2, item: "Eat In" },
        { code: 3, item: "Takeaway" }
      ]
    };
  },
  watch: {
    "info.cloudSettings.length"(newValue) {
      this.deviceUserDefaults = this.info.cloudSettings.find(p => p.deviceUDID == this.info.selectedDevice.deviceUDID)!.userDefaultsObject;
    },
    "info.selectedDevice.deviceUDID"(newValue) {
      this.deviceUserDefaults = this.info.cloudSettings.find(p => p.deviceUDID == this.info.selectedDevice.deviceUDID)!.userDefaultsObject;
    }
  },
  methods: {
    handleSwitchChange(e, prop) {
      this.$set(this.deviceUserDefaults, prop, e.checked);
    },
    async save() {
      try {
        this.saving = true;
        const result = await DeviceOptionsService.updateDeviceOptions(this.info.selectedDevice.deviceUDID, this.deviceUserDefaults);
        if (result) {
          this.notyfy.success("Saved Successfully");
        } else {
          this.notyfy.error("Save Failed");
        }
      } catch (error) {
        this.notyfy.error("Save Failed");
      } finally {
        this.saving = false;
      }
    }
  },
  computed: {}
});
